import { useMarketplaceCategorySearchQuery } from "@/graphql/generated";

export function useMarketplaceCategorySearch(
  marketplace: string,
  keyword: string | null,
  active: boolean,
) {
  const { data, isFetching, error } = useMarketplaceCategorySearchQuery(
    { input: { marketplace, query: keyword ?? "" } },
    { enabled: active && !!keyword },
  );

  return {
    searching: isFetching,
    searchError: error,
    results: (data?.marketplaceCategorySearch.categories ?? []).map((c) => ({
      name: c.categoryName,
      displayName: c.fullPath || c.categoryName,
      categoryId: c.categoryId,
      synced: false,
    })),
  };
}
